import React from 'react';
import { Fade } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import * as HIcons from 'react-icons/hi'

export default function Slideshow(props) {

    return (
        <div className={props.image ? "block lg:py-12 lg:px-36" : "hidden"}>
            <Fade nextArrow={<button style={{
                background: 'none',
                border: '0px',
                width: '30px'
            }}>
                <HIcons.HiArrowCircleRight className='text-[7vw] md:text-[6vw] lg:text-[5vw] text-[#101242] transition-all duration-200 hover:bg-white hover:text-[#ed5955] rounded-full bg-[#F4DC7C] hover:scale-125'/>
                </button>}
                prevArrow={<button style={{
                        background: 'none',
                        border: '0px',
                        width: '30px'
                    }}>
                        <HIcons.HiArrowCircleLeft className='text-[7vw] md:text-[6vw] lg:text-[5vw] text-[#101242] transition-all duration-200 hover:bg-white hover:text-[#ed5955] rounded-full bg-[#F4DC7C] hover:scale-125'/>
                        </button>}
                transitionDuration="500"
                >
                {props.image ? props.image.map((data, i) => {
                    return (
                        <div key={i} className="each-slide-effect">
                            <div style={{ 'backgroundImage': `url(${data.image})` }}>
                                <span className={data.desc ? "block" : "hidden"}>
                                    {data.desc}
                                </span>
                            </div>

                        </div>
                    )
                }) : ""}
            </Fade>
        </div>
    );
}